import { ON_EXCHANGE_PAYMENT_METHODS } from '../../shared/interfaces/on-exchange-enrollment-payment-form.interface';

export interface PostSubmissionPaymentDataInterface extends PaymentDataInterface {
  paymentId: unknown;
}
export interface PaymentDataInterface {
  identifier: unknown;
  pmtMethodCode: unknown;
  pmtMethodType: ON_EXCHANGE_PAYMENT_METHODS;
  productCode: unknown;
  merchantID: unknown;
  accountNum: string;
  invoiceNum: string;
  pmtAmt: number | string; // converted to string for submission
  umi: unknown;
  flmID: unknown;
  createBy: unknown;
  billingAddress: {
    name: unknown;
    addr1: unknown;
    addr2: unknown;
    city: unknown;
    state: unknown;
    zip: unknown;
    country: unknown;
  };
  cardInfo: {
    ccType: 'VI' | 'MC'| 'DI' | 'AX';
    ccExpDt: string;
    ccNumEnc: string;
    ccEncKey: unknown;
  };
  achInfo: {
    custSubBankID: unknown;
    custSubAcctNumEnc: string;
  };
  phoneNum: {
    phoneNum: unknown;
    ext: unknown;
  };
  custAuthCode: unknown;
}

export class PaymentData implements PaymentDataInterface {
  identifier = null;
  pmtMethodCode = null;
  pmtMethodType = null;
  productCode = null;
  merchantID = null;
  accountNum = null;
  invoiceNum = null;
  pmtAmt = null;
  umi = null;
  flmID = null;
  createBy = null;
  billingAddress = {
    name: null,
    addr1: null,
    addr2: null,
    city: null,
    state: null,
    zip: null,
    country: null
  };
  cardInfo = {
    ccType: null,
    ccExpDt: null,
    ccNumEnc: null,
    ccEncKey: null
  };
  achInfo = {
    custSubBankID: null,
    custSubAcctNumEnc: null
  };
  phoneNum = {
    phoneNum: null,
    ext: null
  };
  custAuthCode = null;

  constructor() {}
}
